module.exports = __webpack_public_path__ + "img/5.e67c6963.jpg";